import React from "react";
import {useSelector} from "react-redux";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";
import {appLink} from "@rw/cars_routes";
import {carsTheme} from "@rw/themes";

import {IStore} from "../../../../app/reducers/hybrid_reducer";
import {Container} from "../../../../homepage/components/CarBrandsSection";
import {getOfferCardImage} from "../../../utils/get_offer_card_image";
import {CarBox} from "./CarBox";

const CarGridContainer = styled.section`
    padding: 20px;
    background-color: #f9f9f9;
`;

const Title = styled.h2`
    font-size: 1.5em;
    margin-bottom: 10px;
`;

const Description = styled.p`
    margin-bottom: 20px;
    color: #555;
`;

const grid = (theme: Theme) => css`
    display: grid;
    gap: 20px;
    grid-template-columns: 1fr;

    @media (min-width: ${theme.breakpoints.screen_xxs}) {
        grid-template-columns: repeat(2, 1fr);
    }
    @media (min-width: ${theme.breakpoints.screen_xs}) {
        grid-template-columns: repeat(3, 1fr);
    }
    @media (min-width: ${theme.breakpoints.screen_md}) {
        grid-template-columns: repeat(4, 1fr);
    }
`;

const ctaWrapper = css`
    display: flex;
    justify-content: center;
    margin-top: 28px;
`;

const allOffersCta = css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px 28px;
    font-size: 16px;
    font-weight: 600;
    color: ${carsTheme.colors.brand_primary};
    background: transparent;
    border: 2px solid ${carsTheme.colors.brand_primary};
    border-radius: 4px;
    text-decoration: none;
    cursor: pointer;
    transition:
        color 0.2s ease,
        background 0.2s ease;

    &:hover {
        color: #ffffff;
        background: ${carsTheme.colors.brand_primary};
        text-decoration: none;
    }
`;

export const CarGrid: React.FC = () => {
    const cars = useSelector((store: IStore) => store.carList.cars.latest);
    const allOffersHref = appLink.searchResult.universal({offerType: "osobowe"});

    return (
        <CarGridContainer>
            <Container>
                <Title>Najnowsze oferty samochodów</Title>
                <Description>Znajdź idealny samochód dla siebie spośród naszych najnowszych ofert.</Description>
                <div css={grid}>
                    {cars.map((car, index) => {
                        return (
                            <CarBox
                                key={car.id}
                                id={car.id}
                                brand={car.acf.make}
                                model={car.acf.model}
                                year={Number(car.acf.year)}
                                mileage={Number(car.acf.millage)}
                                price={Number(car.acf.price)}
                                image={getOfferCardImage(car)}
                                slug={car.slug}
                                listName="homepage_latest"
                                position={index + 1}
                            />
                        );
                    })}
                </div>
                <div css={ctaWrapper}>
                    <a css={allOffersCta} href={allOffersHref}>
                        Zobacz wszystkie oferty
                    </a>
                </div>
            </Container>
        </CarGridContainer>
    );
};
